import type React from 'react';
import styled from 'styled-components';

export interface AccentedQuadroLayoutProps {
  topLeftContent: React.ReactNode;
  middleLeftContent: React.ReactNode;
  bottomLeftContent: React.ReactNode;
  mainContent: React.ReactNode;
  footerContent: React.ReactNode;
  collapser?: React.ReactNode;
  isSidebarCollapsed: boolean;
}

export const AccentedQuadroLayout: React.FC<AccentedQuadroLayoutProps> = ({
  topLeftContent,
  middleLeftContent,
  bottomLeftContent,
  mainContent,
  footerContent,
  collapser,
  isSidebarCollapsed
}) => {
  return (
    <Container data-testid="quadro-viewport-layout">
      <SideContentArea
        style={{
          transform: `translateX(${isSidebarCollapsed ? '-100%' : '0'})`
        }}
      >
        <SideContentPlaceholder>{topLeftContent}</SideContentPlaceholder>
        <SideContentPlaceholder>{middleLeftContent}</SideContentPlaceholder>
        <SideContentPlaceholder>{bottomLeftContent}</SideContentPlaceholder>
        {collapser}
      </SideContentArea>
      <MainContentArea
        style={{ marginLeft: isSidebarCollapsed ? `calc(0px - clamp(200px, 25vw, 600px))` : 'unset' }}
        onTransitionEnd={(): void => void window.dispatchEvent(new Event('resize'))}
      >
        <MainContentPlaceholder>{mainContent}</MainContentPlaceholder>
        <FooterPlaceholder>{footerContent}</FooterPlaceholder>
      </MainContentArea>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const SideContentArea = styled.div`
  width: clamp(200px, 25vw, 600px);
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  height: 100%;
  position: relative;
  z-index: 99;  // needs to be less than react-joyride__overlay (100)
  gap: 1px;
  transition: transform 0.3s;
`;

const SideContentPlaceholder = styled.div`
  flex: 1;
`;

const MainContentArea = styled.div`
  flex: 1;
  min-height: 1rem; // to prevent collapsing
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s;
`;

const MainContentPlaceholder = styled.div`
  flex: 1;
`;

const FooterPlaceholder = styled.div``;
